import React, { FC } from 'react';
import '../../styles/components/checkbox.scss';
import { setClass } from '@utils';
import { CheckedIcon } from '../svgs';

interface ICheckboxProps {
  label: string;
  value: boolean;
  color?: string;
  className?: string;
  onChange?: (newValue: boolean) => void;
  labelClassName?: string;
}

export const Checkbox: FC<ICheckboxProps> = ({
  label, value, color, className, onChange, labelClassName
}) => (
  <div
    className={setClass('checkbox-item', className)}
    onClick={() => onChange && onChange(!value)}
  >
    <div
      className="checkbox"
      style={{
        backgroundColor: color,
        border: ` 0.5px solid ${color}`
      }}
    >
      <CheckedIcon divClassName={setClass('done-icon', value && 'active')} />
    </div>
    <label className={setClass('checkbox-label', labelClassName)}>{label}</label>
  </div>
);
